import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { Entry } from 'contentful';
import { IagPortalHowDoesItWorkPage } from 'src/app/model/page/group/iag-portal/iag-portal-how-does-it-work-page';
import { ContentfulService } from 'src/app/service/contentful.service';
import { SharedDataService } from 'src/app/service/shared-data.service';
import { ModelValidator } from 'src/app/validator/model-validator';
import htmlTitle from 'src/assets/json/redirects/html-title.json';

@Component({
  selector: 'app-iag-portal-how-does-it-work-page',
  templateUrl: './iag-portal-how-does-it-work-page.component.html',
  styleUrls: ['./iag-portal-how-does-it-work-page.component.scss']
})
export class IagPortalHowDoesItWorkPageComponent implements OnInit {
  pageName = 'How does it work?';
  collapsedOne: boolean[] = [];

  iagPortalHowDoesItWorkPage: IagPortalHowDoesItWorkPage = {} as IagPortalHowDoesItWorkPage;
  constructor(private contentfulService: ContentfulService, private sharedDataService: SharedDataService, private httpClient: HttpClient) {}

  ngOnInit(): void {
    htmlTitle.filter((title) => {
      if (title.page === 'iag-portal-how-it-works') {
        this.iagPortalHowDoesItWorkPage.htmlTitle = title.htmlTitle;
      }
    });
    this.iagPortalHowDoesItWorkPage.sections = [];
    this.iagPortalHowDoesItWorkPage.howDoesItWorkSectionOne = [];
    this.iagPortalHowDoesItWorkPage.noteSection = [];
    this.iagPortalHowDoesItWorkPage.apiFlowHowDoestItWorkSection = [];
    this.iagPortalHowDoesItWorkPage.bodyAboveAirShoopingRq = [];
    this.iagPortalHowDoesItWorkPage.bodyBelowAirShoopingRq = [];
    this.iagPortalHowDoesItWorkPage.detailsXMLSection = [];
    this.iagPortalHowDoesItWorkPage.accordianAirShoppingRQ = [];
    this.iagPortalHowDoesItWorkPage.assetImages = [];
    const query = { 'fields.title': this.pageName };
    this.contentfulService.getPageContentResponse(query).then((resIncludes) => {
      this.mapBanner(resIncludes.includes.Entry);
      this.sharedDataService.addSharedData(this.iagPortalHowDoesItWorkPage.banner);
      this.mapPageInfo(resIncludes.items);
      this.mapSections(resIncludes.includes.Entry);
      this.mapNoteSections(resIncludes.includes.Entry);
      this.mapImage(resIncludes.includes.Asset);
    });
  }

  private mapBanner(iagPortalHowDoIMakeABookingPageEntries: Entry<any>[]) {
    iagPortalHowDoIMakeABookingPageEntries
      .filter((entry) => ModelValidator.isBanner(entry))
      .forEach((entry) => {
        this.mapEntryToBanner(entry);
      });
  }

  private mapNoteSections(res: Entry<any>[]) {
    res
      .filter((entry) => ModelValidator.isNote(entry))
      .forEach((entry) => {
        this.mapEntryToNoteSection(entry);
      });
  }

  private mapPageInfo(items: Entry<any>[]) {
    items.forEach((entry: any) => {
      let editorDetails = entry.fields?.editorDetails?.split('#');
      this.iagPortalHowDoesItWorkPage.banner.lastUpdated = entry.fields?.lastUpdated;
      this.iagPortalHowDoesItWorkPage.banner.url = entry.fields?.url;
      this.iagPortalHowDoesItWorkPage.banner.editorEmail = editorDetails?.pop();
      this.iagPortalHowDoesItWorkPage.banner.editorShortName = editorDetails?.pop();
      this.iagPortalHowDoesItWorkPage.banner.editorFullName = editorDetails?.pop();
      this.iagPortalHowDoesItWorkPage.htmlTitle = entry.fields.htmlTitle;
    });
  }
  private mapEntryToNoteSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    this.iagPortalHowDoesItWorkPage.noteSection.push({
      fullTitle: entry.fields['title'] as string,
      title: title.split('#').pop(),
      body: entry.fields['body'] as string,
      iconClass: entry.fields['iconClass'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      noteClass: entry.fields['noteClass'] as string
    });
  }

  private mapEntryToBanner(entry: Entry<any>) {
    let image: any = entry.fields['image'] as string;
    this.iagPortalHowDoesItWorkPage.banner = {
      title: entry.fields['title'] as string,
      subTitle: entry.fields['subTitle'] as string,
      image: image.fields.file.url
    };
  }

  private mapSections(iagPortalRoadmapPageEntries: Entry<any>[]) {
    iagPortalRoadmapPageEntries
      .filter((entry) => ModelValidator.isSection(entry))
      .forEach((entry) => {
        this.mapXMLSectionToEntries(entry);
        if (entry.fields['group'] == 'request-response-render') {
          this.mapAPIFlow(entry);
        } else {
          this.mapEntryToSection(entry);
        }
      });
    this.iagPortalHowDoesItWorkPage.sections.sort((a, b) => a.order - b.order);
  }
  mapEntryToSection(entry: Entry<any>) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    this.iagPortalHowDoesItWorkPage.sections.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      titleColorClass: entry.fields['sectionClass'] as string
    });
    this.iagPortalHowDoesItWorkPage.howDoesItWorkSectionOne = this.iagPortalHowDoesItWorkPage.sections.filter((section) => section.group === 'how-does-it-work-section-one');
  }

  private mapAPIFlow(entry: Entry<any>) {
    let tBody: string[] = [];
    let body: any = entry.fields['body'] as string;
    body.split('\n').forEach((apiArrow: any) => {
      if (apiArrow !== '') {
        tBody.push(apiArrow);
      }
    });
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#')[3];
    this.iagPortalHowDoesItWorkPage.apiFlowHowDoestItWorkSection.push({
      title: pageTitle,
      body: entry.fields['subBody'] as string,
      bodyArrows: tBody,
      order: entry.fields['order'] as number,
      group: entry.fields['group'] as string
    });

    this.iagPortalHowDoesItWorkPage.bodyAboveAirShoopingRq = this.iagPortalHowDoesItWorkPage.apiFlowHowDoestItWorkSection.map((section) => section.body.split('#')[0]);
    this.iagPortalHowDoesItWorkPage.bodyBelowAirShoopingRq = this.iagPortalHowDoesItWorkPage.apiFlowHowDoestItWorkSection.map((section) => section.body.split('#')[1]);
  }

  private mapXMLSectionToEntries(entry: Entry<any>) {
    let xml: any = entry.fields['xml'] as string;
    this.httpClient.get(xml?.content[0].data.target.fields.file.url, { responseType: 'text' }).subscribe({
      next: (data: string) => this.mapXMLSectionToEntriesWithXMLData(entry, data),
      error: (cause: { message: string }) => this.mapXMLSectionToEntriesWithXMLData(entry, cause.message)
    });
  }

  private mapXMLSectionToEntriesWithXMLData(entry: Entry<any>, xmlData: string) {
    let title: any = entry.fields['title'] as string;
    let pageTitle = title.split('#').pop();
    let subBody: any = entry.fields['xml'] as string;
    this.iagPortalHowDoesItWorkPage.detailsXMLSection.push({
      title: pageTitle,
      body: entry.fields['body'] as string,
      group: entry.fields['group'] as string,
      order: entry.fields['order'] as number,
      xmlData: xmlData,
      tableSections: [],
      subBody: subBody?.content[0].data.target.fields.title.split('#')[4]
    });

    this.iagPortalHowDoesItWorkPage.accordianAirShoppingRQ = this.iagPortalHowDoesItWorkPage.detailsXMLSection.filter((xml) => xml.title === 'AirShopping RQ');
    this.iagPortalHowDoesItWorkPage.accordianOfferPriceRS = this.iagPortalHowDoesItWorkPage.detailsXMLSection.filter((xml) => xml.title === 'OfferPrice RS');
  }

  private mapImage(assets: Entry<any>[]) {
    const asset = assets
      .filter((asset: any) => asset.fields['title'].split('#')[0] === this.pageName)
      .forEach((images) => {
        this.assetImages(images);
      });
  }

  private assetImages(asset: Entry<any>) {
    let title: any = asset.fields['title'] as string;
    let image: any = asset.fields['file'] as string;
    this.iagPortalHowDoesItWorkPage.assetImages.push({
      title: title.split('#')[1],
      image: image.url,
      description: asset.fields['description'] as string,
      order: Number(title.split('#').pop())
    });
    // console.log();
  }

  public toggleCollapsed(key: number) {
    this.collapsedOne[key] = !this.collapsedOne[key];
  }

  public getAccordionStyle(key: number) {
    return this.collapsedOne[key] ? 'not-collapsed' : 'collapsedOne';
  }

  public getArrowIcons(key: number) {
    return this.collapsedOne[key] ? 'icon-arrowUp' : 'icon-arrowDown';
  }

  public getActiveStyle(key: number) {
    return this.collapsedOne[key] ? 'active' : 'title-hover';
  }
}
